<app-auth-header></app-auth-header>
<div class="container">


    <div class="bg-white mt-5 p-4">

        <table *ngIf="details?.message == 'Found'" class="table table-hover m-5 p-4" style="width: 90%;">

            <tbody>
                <tr *ngIf="details?.photo">

                    <td style="padding-left: 10%;">Photo:</td>
                    <td style="padding-left: 15%;">   <img src= {{details?.photo}} style="width:150px ; height:150px ; border-radius: 5px" alt="user picture" /></td>

                </tr>
                <tr *ngIf="details?.assessmentType">

                    <td style="padding-left: 10%;">Type:</td>
                    <td style="padding-left: 15%;"><b>{{details?.assessmentType | uppercase | removeUnderscores}}</b></td>

                </tr>
                <tr *ngIf="details?.assessmentId">

                    <td style="padding-left: 10%;">AIRMS ID:</td>
                    <td style="padding-left: 15%;"><b>{{details?.assessmentId | uppercase}}</b></td>

                </tr>
                <tr *ngIf="details?.applicationId">

                    <td style="padding-left: 10%;">Application ID:</td>
                    <td style="padding-left: 15%;"><b>{{details?.applicationId | uppercase}}</b></td>

                </tr>
                <tr *ngIf="details?.receiptNo">

                    <td style="padding-left: 10%;">Receipt No.:</td>
                    <td style="padding-left: 15%;"><b>{{details?.receiptNo | uppercase}}</b></td>

                </tr>
                <tr *ngIf="details?.paymentChannel">

                    <td style="padding-left: 10%;">Payment Channel:</td>
                    <td style="padding-left: 15%;"><b>{{details?.paymentChannel | uppercase}}</b></td>

                </tr>
                <tr *ngIf="details?.assessmentYear">

                    <td style="padding-left: 10%;">Assessment Year:</td>
                    <td style="padding-left: 15%;"><b>{{details?.assessmentYear | uppercase}}</b></td>

                </tr>
            <tr>

                <td style="padding-left: 10%;">Full Name:</td>
                <td style="padding-left: 15%;"><b>{{details?.fullName | titlecase}}</b></td>

            </tr>

            <tr *ngIf="details?.asin">

                <td style="padding-left: 10%;">ASIN:</td>
                <td style="padding-left: 15%;"><b>{{details?.asin | uppercase}}</b></td>

            </tr>

            <tr *ngIf="details?.email">

                <td style="padding-left: 10%;">Email:</td>
                <td style="padding-left: 15%;"><b>{{details?.email | lowercase}}</b></td>

            </tr>

            <tr *ngIf="details?.companyName">

                <td style="padding-left: 10%;">Company Name:</td>
                <td style="padding-left: 15%;"><b>{{details?.companyName | titlecase}}</b></td>

            </tr>

            <tr *ngIf="details?.description">

                <td style="padding-left: 10%;">Description:</td>
                <td *ngIf="details?.description && details?.description != 'Not Paid'" style="padding-left: 15%;"><b>{{details?.description | titlecase}}</b></td>
                <td *ngIf="details?.description && details?.description == 'Not Paid'" style="padding-left: 15%; color: red;"><b>{{details?.description | titlecase}}</b></td>

            </tr>

            <tr *ngIf="details?.amount ">

                <td style="padding-left: 10%;">Amount:</td>
                <td style="padding-left: 15%;"><b>{{details?.amount | nairaCurrency}}</b></td>

            </tr>

            <tr *ngIf="details?.paymentStatus">

                <td style="padding-left: 10%;">Payment Status:</td>
                <td *ngIf="details?.paymentStatus && (details?.paymentStatus == 'PAID' || details?.paymentStatus == 'APPROVED')" style="padding-left: 15%; color: rgb(5, 83, 30);"><b>{{details?.paymentStatus | titlecase}}</b></td>
                <td *ngIf="details?.paymentStatus && (details?.paymentStatus != 'PAID' && details?.paymentStatus != 'APPROVED')" style="padding-left: 15%; color: red;"><b>{{details?.paymentStatus | titlecase}}</b></td>

            </tr>
            <tr *ngIf="details?.approvalStatus">
                <td style="padding-left: 10%;">Approval Status:</td>
                <td *ngIf="details?.approvalStatus && (details?.approvalStatus == 'APPROVED')" class="details-head-r" style="padding-left: 15%; color: rgb(5, 83, 30);"><b>{{details?.approvalStatus | titlecase}}</b></td>
                <td *ngIf="details?.approvalStatus && (details?.approvalStatus != 'APPROVED')" class="details-head-r" style="color: red;"><b>{{details?.approvalStatus | titlecase}}</b></td>
            </tr>

            <tr *ngIf="details.paymentDate">

                <td style="padding-left: 10%;">Payment Date:</td>
                <td *ngIf="details.paymentDate && details.paymentDate != 'Not Paid'" style="padding-left: 15%;"><b>{{details?.paymentDate| date}}</b></td>
                <td *ngIf="details.paymentDate && details.paymentDate == 'Not Paid'" style="padding-left: 15%; color: red;"><b>{{details?.paymentDate}}</b></td>

            </tr>
            <tr *ngIf="details?.dateCreated">

                <td style="padding-left: 10%;">Date Created:</td>
                <td style="padding-left: 15%;"><b>{{details?.dateCreated | uppercase}}</b></td>

            </tr>
            </tbody>
        </table>


        <div *ngIf="isLoading"  class="d-flex text-center justify-content-center mt-3">
            <p class="text-muted">Loading... Please wait</p>
          </div>

          <div *ngIf="details?.message == 'Not Found!'"  class="d-flex text-center justify-content-center mt-3">
            <p class="text-danger">Not Found!</p>
          </div>

    </div>

</div>

<div style="height: 969px"></div>

<div style="position: sticky;bottom: 0">
    <app-footer class="m-hidden"></app-footer>
</div>
